export default "__VITE_ASSET__BNse9Fmq__"